<template>
  <div>  
    <div ref="mars3dSplit" id="mars3dSplit" class="mars3d-container1"></div>
    <div>
        <img style="position:absolute; top:5%; right:47.5%" id="layercompareIcon" src="/static/type/layerMg.png" alt="" @click="openLayerCompareManage" >
    </div>
    <layer-management class="layerManagement layerManageCompare" ref='layerManageCompare' :visible="visible" @checkNode="checkNode" @selectedNode="selectedNode" @searchNode="searchNode" @reloadNode="reloadNode"  @closeLayermanagement="closeLayermanagement"></layer-management>
  </div>
</template>

<script>

import layerManagement from '../../../layer-management/index.vue'
  export default {
    name: 'splitCompareMap',
    components: {
      layerManagement
    },
    props:{

    },
    data() {
      return {
        mapOptions:null,
        mapsplitOptions:null,
        mainMapSplit:null,
        visible:true,
        compareBtn:false,//双屏对比的下拉框以及按钮
        selectData:[],//下拉选择框
        loadedData:[],//已经在地图上加载过的图层（checkedKey)
        mainmapDoc:null,
        layerManageClass:'layerManageSplit',
      }
    },
    methods:{
      //plan是选择的key, data是treedata
      initMap(map,splitOption,treedata,checkedKeys,expandedKeys,parentDoucment,mainmapDoc){
        console.log('mainmapDOc',mainmapDoc);
        // this.mapCompare = true      
        // options.layers.forEach(item=>{
        //   item.show = false
        //   item.show = item.id === plan[1] ? true : false
        // })
        mainmapDoc.style.width = '50%'
        this.mainmapDoc = mainmapDoc
        this.mainMap = map

        if(!this.spiltMap){
          this.spiltMap = new mars3d.control.MapCompare({
            ...splitOption,
            parentContainer: parentDoucment
          })
          this.mainMap.addControl(this.spiltMap)

          this.$refs.layerManageCompare.checkedKeys = checkedKeys
          this.$refs.layerManageCompare.expandedKeys = expandedKeys
          this.$refs.layerManageCompare.initMap(this.spiltMap.mapEx,treedata) 
        }
        

        // 修改对比地图
        // mapSplit.mapEx.basemap = '如东2020年度'
        // mapSplit.mapEx.basemap = '天地图电子'
        // console.log('this.spiltMap', this.spiltMap.camera, this.mainMap,mapSplit.scene)
      },
      removeMap(){
        this.mapCompare = false
        if(this.spiltMap){
          this.mainMap.removeControl(this.spiltMap)
          this.spiltMap.destroy()
          this.spiltMap = null
        }
        if(this.mainmapDoc){
          console.log(this.mainmapDoc);
          this.mainmapDoc.style.width = '100%'
        }
        
        // this.$parent.$parent.$parent.$refs.centerDiv.style.width = '100%'
        
        // document.getElementsByClassName('cesium-viewer')[0].style.width = '100%'
        // this.$parent.$parent.$parent.$refs.mapMain.$refs.mars3dContainer.style.width = '100%'
        // this.clearHandler()
        
        
      },
      openLayerCompareManage(){
        console.log('click');
        //这边的map应该是splitMap
        this.visible = true
      },
      checkNode(keys, checkedNode,event){
        this.$refs.layerManageCompare.loadCheckedLayers(checkedNode, event.checked, this.spiltMap.mapEx)
        this.$emit('checkedNodeSplit', checkedNode,event, this.spiltMap.mapEx);
      },
      selectedNode(node){
        console.log('split',node);
        this.$emit('selectedNodeSplit',node)
      },
      searchNode(node){
        this.$emit('searchNodeSplit',node)
      },
      reloadNode(){
        this.$emit('reloadNodeSplit')
      },
      closeLayermanagement(){
        this.visible = false
      }
    }
  }
</script>

<style lang="scss" scoped>
.mars3d-container1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
}
.layerManageCompare{
  top: 5% !important;
  left: 50% !important;
  height: 95% !important;
}
#layercompareIcon:hover {
    cursor: pointer;
}
.layerManageSplit{
  width: 40px;
  height: 40px;
  margin-left: 50%;
}
</style>